import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tarneaeg "Ise järgi" tellides

  <span style="color:#85c1dc;">**FI:**</span>
  

  <span style="color:#85c1dc;">**RU:**</span>
  Срок доставки при заказе "Самовывоз"
*/
/* @__NO_SIDE_EFFECTS__ */
const m47 = msg(
  mf`Tarneaeg "Ise järgi" tellides`,
  mf``,
  mf`Срок доставки при заказе "Самовывоз"`,
)

export { m47 as 'w.module.delivery_section.delivery_time.self_delivery' }